import { render } from "./ChooseSlump.vue?vue&type=template&id=4eed0e92"
import script from "./ChooseSlump.vue?vue&type=script&lang=js"
export * from "./ChooseSlump.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\orcamento-online-concreto\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__